var $02f15591e0ad21a3$exports = {};
/* ============================================================
   AppNavbar — geteilte Navigation (Web Component) + Theme-Toggle
   Verwendung: <app-navbar active="suche"></app-navbar>
   Active-Keys: start | suche | kalender | karte | abstimmungen |
                personen | statistiken | benachrichtigungen | admin
   Vollständig DOM-basiert (kein innerHTML).
   ============================================================ */ const $02f15591e0ad21a3$var$THEME_KEY = "theme";
const $02f15591e0ad21a3$var$SVG_NS = "http://www.w3.org/2000/svg";
// ── Theme-Toggle ─────────────────────────────────────────────
function $02f15591e0ad21a3$var$getEffectiveTheme() {
    const saved = localStorage.getItem($02f15591e0ad21a3$var$THEME_KEY);
    if (saved === "dark" || saved === "light") return saved;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function $02f15591e0ad21a3$var$updateToggleButton() {
    const btn = document.getElementById("theme-toggle");
    if (btn) btn.setAttribute("data-mode", $02f15591e0ad21a3$var$getEffectiveTheme());
}
function $02f15591e0ad21a3$var$toggleTheme() {
    const next = $02f15591e0ad21a3$var$getEffectiveTheme() === "dark" ? "light" : "dark";
    localStorage.setItem($02f15591e0ad21a3$var$THEME_KEY, next);
    document.documentElement.setAttribute("data-theme", next);
    $02f15591e0ad21a3$var$updateToggleButton();
}
// ── SVG-Helfer (baut echte SVG-Knoten aus [tag, attrs]-Listen) ──
function $02f15591e0ad21a3$var$svgIcon(paths, cls = "lc-icon") {
    const svg = document.createElementNS($02f15591e0ad21a3$var$SVG_NS, "svg");
    for (const [k, v] of Object.entries({
        class: cls,
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
    }))svg.setAttribute(k, v);
    for (const [tag, attrs] of paths){
        const node = document.createElementNS($02f15591e0ad21a3$var$SVG_NS, tag);
        for (const [k, v] of Object.entries(attrs))node.setAttribute(k, v);
        svg.appendChild(node);
    }
    return svg;
}
const $02f15591e0ad21a3$var$ICONS = {
    search: [
        [
            "path",
            {
                d: "m21 21-4.34-4.34"
            }
        ],
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8"
            }
        ]
    ],
    calendar: [
        [
            "path",
            {
                d: "M8 2v4"
            }
        ],
        [
            "path",
            {
                d: "M16 2v4"
            }
        ],
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "4",
                rx: "2"
            }
        ],
        [
            "path",
            {
                d: "M3 10h18"
            }
        ]
    ],
    map: [
        [
            "path",
            {
                d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "10",
                r: "3"
            }
        ]
    ],
    votes: [
        [
            "path",
            {
                d: "M18 6 7 17l-5-5"
            }
        ],
        [
            "path",
            {
                d: "m22 10-7.5 7.5L13 16"
            }
        ]
    ],
    stats: [
        [
            "path",
            {
                d: "M5 21v-6"
            }
        ],
        [
            "path",
            {
                d: "M12 21V3"
            }
        ],
        [
            "path",
            {
                d: "M19 21V9"
            }
        ]
    ],
    people: [
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4"
            }
        ],
        [
            "path",
            {
                d: "M22 21v-2a4 4 0 0 0-3-3.87"
            }
        ],
        [
            "path",
            {
                d: "M16 3.13a4 4 0 0 1 0 7.75"
            }
        ]
    ],
    user: [
        [
            "path",
            {
                d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "7",
                r: "4"
            }
        ]
    ],
    shield: [
        [
            "path",
            {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
            }
        ]
    ],
    menu: [
        [
            "line",
            {
                x1: "4",
                x2: "20",
                y1: "6",
                y2: "6"
            }
        ],
        [
            "line",
            {
                x1: "4",
                x2: "20",
                y1: "12",
                y2: "12"
            }
        ],
        [
            "line",
            {
                x1: "4",
                x2: "20",
                y1: "18",
                y2: "18"
            }
        ]
    ]
};
// ── Navigationslinks ─────────────────────────────────────────
const $02f15591e0ad21a3$var$NAV_LINKS = [
    {
        href: "/suche",
        key: "suche",
        label: "Suche",
        icon: $02f15591e0ad21a3$var$ICONS.search
    },
    {
        href: "/kalender",
        key: "kalender",
        label: "Kalender",
        icon: $02f15591e0ad21a3$var$ICONS.calendar
    },
    {
        href: "/karte",
        key: "karte",
        label: "Karte",
        icon: $02f15591e0ad21a3$var$ICONS.map
    },
    {
        href: "/abstimmungen",
        key: "abstimmungen",
        label: "Abstimmungen",
        icon: $02f15591e0ad21a3$var$ICONS.votes
    },
    {
        href: "/personen",
        key: "personen",
        label: "Personen",
        icon: $02f15591e0ad21a3$var$ICONS.people
    },
    {
        href: "/statistik",
        key: "statistiken",
        label: "Statistik",
        icon: $02f15591e0ad21a3$var$ICONS.stats
    },
    {
        href: "/konto",
        key: "benachrichtigungen",
        label: "Konto",
        icon: $02f15591e0ad21a3$var$ICONS.user
    }
];
// Seiten bleiben direkt erreichbar, auch wenn ihr Navigationspunkt vorläufig
// nicht angeboten wird.
const $02f15591e0ad21a3$var$HIDDEN_NAV_KEYS = new Set([
    "personen"
]);
function $02f15591e0ad21a3$var$navLink({ href: href, key: key, label: label, icon: icon }, active) {
    const a = document.createElement("a");
    a.href = href;
    a.className = "nav-link" + (key === active ? " active" : "");
    if (key === active) a.setAttribute("aria-current", "page");
    a.appendChild($02f15591e0ad21a3$var$svgIcon(icon));
    a.appendChild(document.createTextNode(label));
    return a;
}
// ── Custom Element ───────────────────────────────────────────
class $02f15591e0ad21a3$var$AppNavbar extends HTMLElement {
    connectedCallback() {
        const active = this.getAttribute("active") || "";
        const skipLink = document.createElement("a");
        skipLink.href = "#main-content";
        skipLink.className = "skip-link";
        skipLink.textContent = "Zum Hauptinhalt";
        const nav = document.createElement("nav");
        nav.className = "navbar";
        nav.setAttribute("aria-label", "Hauptnavigation");
        const container = document.createElement("div");
        container.className = "navbar-container";
        const brand = document.createElement("a");
        brand.href = "/";
        brand.className = "navbar-brand";
        brand.setAttribute("aria-label", "Ratsinfo Cuxland \u2013 Startseite");
        brand.appendChild(document.createTextNode("Ratsinfo Cuxland"));
        const links = document.createElement("div");
        links.className = "navbar-links";
        links.id = "navbar-links";
        for (const link of $02f15591e0ad21a3$var$NAV_LINKS)if (!$02f15591e0ad21a3$var$HIDDEN_NAV_KEYS.has(link.key)) links.appendChild($02f15591e0ad21a3$var$navLink(link, active));
        const actions = document.createElement("div");
        actions.className = "navbar-actions";
        const version = document.createElement("span");
        version.className = "deployment-version";
        version.hidden = true;
        version.title = "Aktuell deployte Version";
        const themeBtn = document.createElement("button");
        themeBtn.id = "theme-toggle";
        themeBtn.className = "theme-toggle";
        themeBtn.setAttribute("aria-label", "Farbschema wechseln");
        themeBtn.setAttribute("data-mode", "light");
        themeBtn.appendChild($02f15591e0ad21a3$var$svgIcon([
            [
                "path",
                {
                    d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
                }
            ]
        ], "icon-moon"));
        themeBtn.appendChild($02f15591e0ad21a3$var$svgIcon([
            [
                "circle",
                {
                    cx: "12",
                    cy: "12",
                    r: "4"
                }
            ],
            [
                "path",
                {
                    d: "M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
                }
            ]
        ], "icon-sun"));
        const toggle = document.createElement("button");
        toggle.className = "nav-toggle";
        toggle.setAttribute("aria-label", "Men\xfc \xf6ffnen");
        toggle.setAttribute("aria-expanded", "false");
        toggle.setAttribute("aria-controls", "navbar-links");
        toggle.appendChild($02f15591e0ad21a3$var$svgIcon($02f15591e0ad21a3$var$ICONS.menu, "lc-icon"));
        actions.appendChild(version);
        actions.appendChild(themeBtn);
        actions.appendChild(toggle);
        container.appendChild(brand);
        container.appendChild(links);
        container.appendChild(actions);
        nav.appendChild(container);
        this.append(skipLink, nav);
        themeBtn.addEventListener("click", $02f15591e0ad21a3$var$toggleTheme);
        $02f15591e0ad21a3$var$updateToggleButton();
        toggle.addEventListener("click", ()=>{
            const open = links.classList.toggle("open");
            toggle.classList.toggle("active", open);
            toggle.setAttribute("aria-expanded", open ? "true" : "false");
            toggle.setAttribute("aria-label", open ? "Men\xfc schlie\xdfen" : "Men\xfc \xf6ffnen");
        });
        links.addEventListener("click", (event)=>{
            if (!event.target.closest("a")) return;
            links.classList.remove("open");
            toggle.classList.remove("active");
            toggle.setAttribute("aria-expanded", "false");
            toggle.setAttribute("aria-label", "Men\xfc \xf6ffnen");
        });
        document.addEventListener("keydown", (event)=>{
            if (event.key !== "Escape" || !links.classList.contains("open")) return;
            links.classList.remove("open");
            toggle.classList.remove("active");
            toggle.setAttribute("aria-expanded", "false");
            toggle.setAttribute("aria-label", "Men\xfc \xf6ffnen");
            toggle.focus();
        });
        fetch("/api/version").then((res)=>res.ok ? res.json() : null).then((data)=>{
            if (!(data === null || data === void 0 ? void 0 : data.version)) return;
            version.textContent = `v${data.version}`;
            version.hidden = false;
        }).catch(()=>{
        /* Die Navigation bleibt ohne Versionshinweis vollständig nutzbar. */ });
        $02f15591e0ad21a3$var$maybeAddAdminLink(links, active);
    }
}
// Admin-Link nur zeigen, wenn der eingeloggte Nutzer Admin ist.
async function $02f15591e0ad21a3$var$maybeAddAdminLink(linksContainer, active) {
    try {
        const res = await fetch("/api/admin/me", {
            credentials: "same-origin"
        });
        if (!res.ok) return;
        const me = await res.json();
        if (!me.isAdmin) return;
    } catch  {
        return;
    }
    linksContainer.appendChild($02f15591e0ad21a3$var$navLink({
        href: "/admin",
        key: "admin",
        label: "Admin",
        icon: $02f15591e0ad21a3$var$ICONS.shield
    }, active));
}
customElements.define("app-navbar", $02f15591e0ad21a3$var$AppNavbar);


//# sourceMappingURL=abstimmungen.f12e2d20.js.map
